function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import localeKeys from '../../../../../locales/keys';
import MetadataActions from 'invision-core/src/components/metadata/metadata.actions';
import MetadataConstants from 'invision-core/src/components/metadata/metadata.constants';
import MetadataSelectors from 'invision-core/src/components/metadata/metadata.selectors';
import { transactionTypeNameIdentifier } from '../../transactions.helpers';
function getExternalBillSubTypeLabel(subType, metadataItems) {
  var _find;
  if (subType === undefined || subType === null || subType === '') {
    return '';
  }
  return ((_find = (metadataItems !== null && metadataItems !== void 0 ? metadataItems : []).find(function (item) {
    return String(item.Value) === String(subType);
  })) === null || _find === void 0 ? void 0 : _find.Name) || '';
}
var TransactionTypeController = /*#__PURE__*/function () {
  function TransactionTypeController($ngRedux) {
    _classCallCheck(this, TransactionTypeController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      localeKeys: localeKeys,
      transactionTypeNameIdentifier: transactionTypeNameIdentifier
    });
  }
  return _createClass(TransactionTypeController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          externalBillSubTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.ExternalBillSubType, store),
          externalBillSubTypeMetadata: MetadataSelectors.codes.MetadataCodeSelector(MetadataConstants.codes.ExternalBillSubType, store)
        };
      };
      var controllerActions = {
        fetchCodeType: MetadataActions.codes.fetchCodeTypes
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if (!this.state.externalBillSubTypeLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.ExternalBillSubType);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.onClose()();
    }
  }, {
    key: "isCurrency",
    get: function get() {
      return !!this.transaction.Currency;
    }
  }, {
    key: "isBrandableCurrency",
    get: function get() {
      return !!this.transaction.BrandableCurrency;
    }
  }, {
    key: "paymentTypeName",
    value: function paymentTypeName() {
      var _this$paymentInstrume, _this$paymentInstrume2, _this$state$externalB, _this$state, _this$state$externalB2;
      var subType = (_this$paymentInstrume = this.paymentInstrument) === null || _this$paymentInstrume === void 0 ? void 0 : (_this$paymentInstrume2 = _this$paymentInstrume.ExternalBill) === null || _this$paymentInstrume2 === void 0 ? void 0 : _this$paymentInstrume2.SubType;
      var items = (_this$state$externalB = (_this$state = this.state) === null || _this$state === void 0 ? void 0 : (_this$state$externalB2 = _this$state.externalBillSubTypeMetadata) === null || _this$state$externalB2 === void 0 ? void 0 : _this$state$externalB2.items) !== null && _this$state$externalB !== void 0 ? _this$state$externalB : [];
      if (!items.length) {
        return '';
      }
      return getExternalBillSubTypeLabel(subType, items);
    }
  }]);
}();
export default {
  template: require('./transaction.type.popup.html'),
  bindings: {
    transaction: '<',
    paymentInstrument: '<',
    paypalPaymentTypes: '<',
    posPaymentTypes: '<',
    onClose: '&'
  },
  controller: TransactionTypeController,
  controllerAs: 'TransactionType'
};